const filtrCzastekStalych = { t: 'Filtr cząstek stałych', name: 'filtr-czastek-stalych' }
export default filtrCzastekStalych